import { createContext, useContext } from "react";

import { DialogState } from "../types";

interface DialogContextInterface {
  dialogState: DialogState;
  setDialogState: (
    value: DialogState | ((prev: DialogState) => DialogState),
  ) => void;
}

const emptyDialogState: DialogState = {
  shouldOpen: false,
  type: "",
};

const defaultDialogState = {
  dialogState: emptyDialogState,
  setDialogState: (): DialogState => emptyDialogState,
};

const DialogContext = createContext<DialogContextInterface>(defaultDialogState);

export const useDialogContext = (): DialogContextInterface =>
  useContext(DialogContext);

export default DialogContext;
